import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ShopService } from '@app/services/shops/shop.service';
import { getToggleSelectorFromFieldName } from '../../store/selectors/dashboard';
import { IState } from '../../store/states';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-dashboard-special-features-section-report-subsection',
  templateUrl: './dashboard-special-features-section-report-subsection.component.html',
  styleUrls: ['./dashboard-special-features-section-report-subsection.component.scss', '../../styles/_dashboard.scss'],
  standalone: false,
})
export class DashboardSpecialFeaturesSectionReportSubsectionComponent implements OnInit {
  @Input() title: string;
  @Input() fieldName: string;
  @Input() action: any;

  private _currentShopId: number;

  value$: Observable<number>;

  constructor(
    private _dashboardStore: Store<IState>,
    private _shopService: ShopService,
  ) {}

  ngOnInit(): void {
    const selector = getToggleSelectorFromFieldName(this.fieldName);
    this.value$ = this._dashboardStore.select(selector);

    this._shopService.shop$.pipe(untilDestroyed(this)).subscribe((currentShop) => {
      this._currentShopId = currentShop?.id;
    });
  }

  onDownloadClick() {
    this._dashboardStore.dispatch(this.action({ shopId: this._currentShopId }));
  }
}
